import React, { useState, useEffect, useMemo, useRef } from "react";
import Cookies from "js-cookie";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import Content from "./Content";
import MCQ from "./MCQ";
import TrueFalse from "./TrueFalse";
import Fillups from "./Fillups";
import ConversationalAnalysis from "./ConversationalAnalysis";
import Match from "./Match";
import AiTutor from "./AiTutor";
import {
  getTestData,
  sendAiTutorData,
  submitQuizResults,
  getQuizResult,
} from "../helper/apicalls/test";
import {
  submitActiveRecallCompleted,
  getActiveRecallCompletedApi,
} from "../helper/apicalls/activeRecall";
import { regenerateContentQuizApi } from "../helper/apicalls/subtopic";

import VideoPlayer from "./VideoPlayer";
import CourseCard from "./CourseCard";
import PdfViewer from "../pages/PdfViewer";
import CourseVerticallCard from "./courseVerticallCard";
import StartTestCard from "./StartTestCard";
import MaterialsRenderer from "./MaterialsRenderer";
import PsychologyIcon from "@mui/icons-material/Psychology";
import CloseIcon from "@mui/icons-material/Close";
import edluminaLogo from "../assets/png/edluminaLogo.png";

import "../styles/Course.scss";
import GlobalLoader from "./GlobalLoader";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "../styles/MixedContent.scss";
import "../styles/TestPage.scss";
import TooltipComponent from "./tooltipComponent";
import "../styles/popup.scss";
import FeedbackPopup from "./FeedbackPopup";
import AnimatedCircularProgress from "./AnimatedCircularProgress";
import AiGenerationPopup from "./AiGenerationPopup";
import Lottie from "lottie-react";
import goldCoinAnimation from "../assets/lottie-json/goldcoin.json";
import levelUpAnimation from "../assets/lottie-json/levelup.json";
import Confetti from "react-confetti";
import { checkIsAdmin, checkIsAiEvalEnabled } from "../helper/authUtils";
import { getUserAiEvalDetails, getUserAiEvalContent, getUserAiEvalQuiz, getUserAiEvalTest, regenerateUserAiEvalTest } from "../helper/apicalls/user";
import AiEvalBreakdownPopup from "./common/AiEvalBreakdownPopup";
import lockIcon from "../assets/png/lockIcon.png";
import {
  generateCoursePersonalizedContent,
  generateSubjectPersonalizedContent,
  generateTopicPersonalizedContent,
  generateSubtopicPersonalizedContent,
  createCoursePersonalizedContent,
  createSubjectPersonalizedContent,
  createTopicPersonalizedContent,
  createSubtopicPersonalizedContent,
  getCoursePersonalizedContent,
  getSubjectPersonalizedContent,
  getTopicPersonalizedContent,
  getSubtopicPersonalizedContent,
  generatePersonlizedContentAudiobook,
} from "../helper/apicalls/personalizedContent";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import SuccessPopup from "./common/SuccessPopup";
import ContentQuizPopup from "./ContentQuizPopup";

const parseContent = (content) => {
  if (!content) return {};
  if (typeof content === "object") return content;

  if (typeof content === "string") {
    try {
      return JSON.parse(content);
    } catch (error) {
      try {
        const cleaned = content.replace(/\\"/g, '"').replace(/^"|"$/g, "");
        return JSON.parse(cleaned);
      } catch (innerError) {
        console.error("Error parsing content JSON:", error);
        return {};
      }
    }
  }
  return content;
};

const RenderPage = ({
  activeComponent,
  selectedCourse,
  subjects = [],
  sampleQuestions = [],
  tfQuestions = [],
  activeId,
  onSelectLeft,
  contentData,
  isLoading,
  mcqCurrent,
  setMcqCurrent,
  mcqAnswers,
  setMcqAnswers,
  pageName,
  pageKey,
  pageTitle,
  mixedCurrentIndex: propMixedIndex,
  setMixedCurrentIndex: propSetMixedIndex,
  completed,
  handleCompletedClick,
  rightActiveId,
  isMarkAsComplete,
  setIsMarkAsComplete,
  parent,
  isPageLocked = false,
  audiourl,
  isInstitution = false,
  contentQuizData = null,
  refreshContentQuizData,
  onQuizSubmitSuccess,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [testResult, setTestResult] = useState(null);
  const [showAiTutor, setShowAiTutor] = useState(false);
  const [showAiPopup, setShowAiPopup] = useState(false);
  const [aiLessons, setAiLessons] = useState(null);
  const [aiTutorContentId, setAiTutorContentId] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState(null);
  const [showAssistant, setShowAssistant] = useState(false);
  const [internalMixedIndex, setInternalMixedIndex] = useState(0);
  const [isTestSubmitted, setIsTestSubmitted] = useState(false);
  const [score, setScore] = useState(0);
  const [testPageData, setTestPageData] = useState(null);
  const [testPageLoading, setTestPageLoading] = useState(false);
  const [lastTestRewards, setLastTestRewards] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isPageCompleted, setIsPageCompleted] = useState(false);
  const [expandedWeakTopics] = useState({});
  const [showSolutions, setShowSolutions] = useState(false);
  const [lastCheckedId, setLastCheckedId] = useState(null);
  const [resultsLoading, setResultsLoading] = useState(false);
  const [isReattempting, setIsReattempting] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [overrideContentData] = useState(null);
  const [personalizedContentData, setPersonalizedContentData] = useState(null);
  const [personalizedContentId, setPersonalizedContentId] = useState(null);
  const [contentEvals, setContentEvals] = useState({});
  const [quizEvals, setQuizEvals] = useState({});
  const [evalLoading, setEvalLoading] = useState(false);
  const [isRegeneratingTest, setIsRegeneratingTest] = useState(false);
  const [evalPopupOpen, setEvalPopupOpen] = useState(false);
  const [selectedEvalData, setSelectedEvalData] = useState(null);
  console.log("isPageLocked", isPageLocked);

  const parseScore = (val) => {
    if (val === undefined || val === null) return null;
    if (typeof val === "number") return val;
    const parsed = parseFloat(val);
    return isNaN(parsed) ? val : parsed;
  };

  const parseJsonOrObject = (val) => {
    if (!val) return {};
    if (typeof val === "object") return val;
    if (typeof val === "string") {
      try {
        return JSON.parse(val);
      } catch (e) {
        try {
          const validJson = val.replace(/'/g, '"');
          return JSON.parse(validJson);
        } catch (e2) {
          return {};
        }
      }
    }
    return {};
  };

  const isContentPageType = () => {
    return (
      activeComponent === "content"    );
  };

  const fetchContentEvals = async () => {
    if (!checkIsAiEvalEnabled() || checkIsAdmin()) return;
    if (!isContentPageType()) return;
    if (!personalizedContentId) return;
    if (contentEvals[personalizedContentId]) return;

    try {
      const title = (pageTitle || "subtopic").toLowerCase();
      const params = { content_id: personalizedContentId, title };
      const res = await getUserAiEvalContent(params);
      if (res && res.success) {
        const evalItem = res.evaluation || (res.evaluations && res.evaluations[personalizedContentId]);
        if (evalItem) {
          setContentEvals((prev) => ({
            ...prev,
            [personalizedContentId]: {
              overall_score: parseScore(evalItem.overall_score),
              evalution_score: parseJsonOrObject(evalItem.evalution_score)
            }
          }));
        } else if (res.evaluations) {
          const parsedEvals = {};
          Object.entries(res.evaluations).forEach(([id, evalItem]) => {
            parsedEvals[id] = {
              overall_score: parseScore(evalItem.overall_score),
              evalution_score: parseJsonOrObject(evalItem.evalution_score)
            };
          });
          setContentEvals(parsedEvals);
        }
      }
    } catch (err) {
      console.error("Failed to load user content AI evaluations:", err);
    }
  };


  const pollPersonalizedContentEval = (targetContentId) => {
    if (!targetContentId || !checkIsAiEvalEnabled() || checkIsAdmin()) return;
    if (!isContentPageType()) return;
    let attempts = 0;
    const maxAttempts = 5;
    const interval = setInterval(async () => {
      attempts++;
      try {
        const title = (pageTitle || "subtopic").toLowerCase();
        const res = await getUserAiEvalContent({ content_id: targetContentId, title });
        const evalItem = res?.evaluation || (res?.evaluations && res.evaluations[targetContentId]);
        if (res && res.success && evalItem) {
          setContentEvals((prev) => ({
            ...prev,
            [targetContentId]: {
              overall_score: parseScore(evalItem.overall_score),
              evalution_score: parseJsonOrObject(evalItem.evalution_score),
            },
          }));
          clearInterval(interval);
        }
      } catch (err) {
        console.error("Error polling personalized content eval:", err);
      }
      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 3000);
  };




  const fetchQuizEvals = async (forceRefresh = false) => {
    if (!checkIsAiEvalEnabled() || checkIsAdmin()) return null;
    if (!isContentPageType()) return null;
    try {
      const title = (pageTitle || "subtopic").toLowerCase();
      const completionIdFromQuiz = Array.isArray(contentQuizData)
        ? contentQuizData[0]?.id
        : contentQuizData?.id;
      const pageCompletionId = testPageData?.id || completionIdFromQuiz;
      const targetId = pageCompletionId || activeId;
      if (!targetId) return null;
      if (!forceRefresh && (quizEvals[targetId] || (activeId && quizEvals[activeId]))) {
        return quizEvals[targetId] || (activeId && quizEvals[activeId]);
      }

      const params = {
        quiz_id: targetId,
        title,
      };
      const res = await getUserAiEvalQuiz(params);
      if (res && res.success) {
        let newEvals = {};
        let resultEval = null;

        if (res.evaluations && typeof res.evaluations === "object") {
          Object.entries(res.evaluations).forEach(([id, evalItem]) => {
            if (evalItem) {
              const parsed = {
                overall_score: parseScore(evalItem.overall_score),
                evalution_score: parseJsonOrObject(evalItem.evalution_score),
              };
              newEvals[id] = parsed;
              if (!resultEval) resultEval = parsed;
            }
          });
        }
        if (res.evaluation) {
          const evalObj = {
            overall_score: parseScore(res.evaluation.overall_score),
            evalution_score: parseJsonOrObject(res.evaluation.evalution_score),
          };
          if (activeId) newEvals[activeId] = evalObj;
          if (pageCompletionId) newEvals[pageCompletionId] = evalObj;
          if (targetId) newEvals[targetId] = evalObj;
          resultEval = evalObj;
        }
        setQuizEvals((prev) => ({ ...prev, ...newEvals }));
        return resultEval;
      }
    } catch (err) {
      console.error("Failed to load user quiz AI evaluations:", err);
    }
    return null;
  };

  const pollQuizEval = (targetId, maxAttempts = 6, delay = 3000) => {
    let attempts = 0;
    const interval = setInterval(async () => {
      attempts += 1;
      const evalObj = await fetchQuizEvals(true);
      if (evalObj || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, delay);
  };


  const [testEvals, setTestEvals] = useState({});

  const fetchTestEvals = async () => {
    if (!checkIsAiEvalEnabled() || checkIsAdmin()) return;

    const isTestOrHome =
      activeComponent === "test" ||
      activeComponent === "active_recall_test" ;

    if (!isTestOrHome) return;

    const key = getTestEvalKey();
    if (!key) return;
    if (testEvals[key]) return;


    try {
      const params = activeComponent === "active_recall_test"
        ? { active_recall_completed_id: key }
        : { test_result_id: key };

      const res = await getUserAiEvalTest(params);
      if (res && res.success) {
        const evalItem = res.evaluation || (res.evaluations && res.evaluations[key]);
        if (evalItem) {
          setTestEvals((prev) => ({
            ...prev,
            [key]: {
              overall_score: parseScore(evalItem.overall_score),
              evalution_score: parseJsonOrObject(evalItem.evalution_score)
            }
          }));
        } else if (res.evaluations) {
          const parsedEvals = {};
          Object.entries(res.evaluations).forEach(([id, item]) => {
            parsedEvals[id] = {
              overall_score: parseScore(item.overall_score),
              evalution_score: parseJsonOrObject(item.evalution_score)
            };
          });
          setTestEvals((prev) => ({ ...prev, ...parsedEvals }));
        }
      }
    } catch (err) {
      console.error("Failed to load user test AI evaluations:", err);
    }
  };

  const toIdString = (val) => {
    if (!val) return null;
    if (typeof val === "string") return val;
    if (typeof val === "object") {
      if (val.$oid) return val.$oid;
      if (val.id) return toIdString(val.id);
      if (val._id) return toIdString(val._id);
    }
    return String(val);
  };

  const getTestEvalKey = () => {
    if (!testResult) return null;
    const candidates = [
      toIdString(testResult.id),
      toIdString(testResult._id),
      toIdString(testResult.summary?.id),
      toIdString(testResult.summary?._id),
      toIdString(testResult.summary?.test_result_id)
    ];
    for (const cand of candidates) {
      if (cand && testEvals[cand]) {
        return cand;
      }
    }
    for (const cand of candidates) {
      if (cand) return cand;
    }
    return null;
  };

  useEffect(() => {
    fetchContentEvals();
    fetchQuizEvals();
    fetchTestEvals();
    setAiLessons(null);
    setAiLoading(false);
    setAiError(null);
    setAiTutorContentId(null);
    setShowAiTutor(false);
  }, [personalizedContentId, activeId, testPageData?.id, contentQuizData?.[0]?.id]);



  useEffect(() => {
    if (!testResult || !checkIsAiEvalEnabled() || checkIsAdmin()) return;

    const isTestOrHome =
      activeComponent === "test" ||
      activeComponent === "active_recall_test" ;

    if (!isTestOrHome) return;


    let isMounted = true;
    let intervalId = null;
    let attempts = 0;
    const maxAttempts = 3; // make for three time

    const doFetch = async () => {
      const key = getTestEvalKey();
      if (!key) return false;
      try {
        const queryParams = activeComponent === "active_recall_test"
          ? { active_recall_completed_id: key }
          : { test_result_id: key };
        const res = await getUserAiEvalTest(queryParams);

        if (!isMounted) return false;
        const evalItem = res?.evaluation || (res?.evaluations && res.evaluations[key]);
        if (res && res.success && evalItem) {
          setTestEvals((prev) => ({
            ...prev,
            [key]: {
              overall_score: parseScore(evalItem.overall_score),
              evalution_score: parseJsonOrObject(evalItem.evalution_score)
            }
          }));
          return true;
        }
      } catch (err) {
        console.error("Fetch test evaluations failed:", err);
      }
      return false;
    };

    const startPolling = async () => {
      const found = await doFetch();
      if (found || !isMounted) return;

      intervalId = setInterval(async () => {
        attempts++;
        if (attempts >= maxAttempts) {
          if (intervalId) clearInterval(intervalId);
          return;
        }
        const success = await doFetch();
        if (success || !isMounted) {
          if (intervalId) clearInterval(intervalId);
        }
      }, 4000);
    };

    startPolling();

    return () => {
      isMounted = false;
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [testResult, isTestSubmitted]);

  const handleQuizAiEvalClick = () => {
    if (!activeId || !quizEvals[activeId]) return;
    setSelectedEvalData(quizEvals[activeId]);
    setEvalPopupOpen(true);
  };

  const handleTestAiEvalClick = async () => {
    const key = getTestEvalKey();
    if (!key) return;
    if (testEvals[key]) {
      setSelectedEvalData(testEvals[key]);
      setEvalPopupOpen(true);
      return;
    }
    setEvalLoading(true);
    try {
      const data = await getUserAiEvalDetails("active_recall_test", key);
      if (data && data.is_evaluated && data.data) {
        const rec = typeof data.data === "string" ? JSON.parse(data.data) : data.data;
        const parsed = {
          overall_score: parseScore(rec.overall_score),
          evalution_score: parseJsonOrObject(rec.evalution_score)
        };
        setTestEvals((prev) => ({ ...prev, [key]: parsed }));
        setSelectedEvalData(parsed);
      } else {
        setSelectedEvalData(data);
      }
      setEvalPopupOpen(true);
    } catch (err) {
      console.error("Failed to fetch AI evaluation details for test:", err);
    } finally {
      setEvalLoading(false);
    }
  };

  const handleRegenerateTestEval = async () => {
    const key = getTestEvalKey();
    if (!key) return;
    setIsRegeneratingTest(true);
    setEvalLoading(true);
    setTestEvals((prev) => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
    try {
      const isActiveRecall = activeComponent === "active_recall_test";
      const params = isActiveRecall
        ? { active_recall_completed_id: key, title: pageTitle, key: pageKey }
        : { test_result_id: key, title: pageTitle, key: pageKey };

      const res = await regenerateUserAiEvalTest(params);
      if (res && res.success) {
        if (res.feedback) {
          const parsedFeedback = typeof res.feedback === "string" ? JSON.parse(res.feedback) : res.feedback;
          setTestResult((prev) => {
            if (!prev) return prev;
            return {
              ...prev,
              feedback: parsedFeedback,
              summary: {
                ...(prev.summary || {}),
                feedback: parsedFeedback,
              },
            };
          });
        }
        setIsRegeneratingTest(false);

        if (res.evaluation) {
          const evalObj = {
            overall_score: parseScore(res.evaluation.overall_score),
            evalution_score: parseJsonOrObject(res.evaluation.evalution_score),
          };
          setTestEvals((prev) => ({
            ...prev,
            [key]: evalObj,
          }));
          setEvalLoading(false);
        } else {
          const queryParams = isActiveRecall
            ? { active_recall_completed_id: key }
            : { test_result_id: key };
          let attempts = 0;
          const pollInterval = setInterval(async () => {
            attempts++;
            try {
              const evalRes = await getUserAiEvalTest(queryParams);
              const evalItem = evalRes?.evaluation || (evalRes?.evaluations && evalRes.evaluations[key]);
              if (evalRes?.success && evalItem) {
                setTestEvals((prev) => ({
                  ...prev,
                  [key]: {
                    overall_score: parseScore(evalItem.overall_score),
                    evalution_score: parseJsonOrObject(evalItem.evalution_score),
                  },
                }));
                setEvalLoading(false);
                clearInterval(pollInterval);
              }
            } catch (e) {
              console.error("Polling test evaluation failed:", e);
            }
            if (attempts >= 10) {
              setEvalLoading(false);
              clearInterval(pollInterval);
            }
          }, 3000);
        }
      } else {
        setIsRegeneratingTest(false);
        setEvalLoading(false);
      }
    } catch (err) {
      console.error("Failed to regenerate test AI evaluation:", err);
      setIsRegeneratingTest(false);
      setEvalLoading(false);
    }
  };



  const handleAiEvalClick = async () => {
    if (!personalizedContentId) return;
    setEvalLoading(true);
    try {
      const data = await getUserAiEvalDetails("personalized_content", personalizedContentId);
      setSelectedEvalData(data);
      setEvalPopupOpen(true);
      if (data && data.is_evaluated && data.data) {
        const rec = typeof data.data === "string" ? JSON.parse(data.data) : data.data;
        const oScore = parseScore(rec.overall_score);
        const eScore = parseJsonOrObject(rec.evalution_score);
        setContentEvals((prev) => ({
          ...prev,
          [personalizedContentId]: {
            overall_score: oScore,
            evalution_score: eScore
          }
        }));
      }
    } catch (err) {
      console.error("Failed to fetch AI evaluation details for content:", err);
    } finally {
      setEvalLoading(false);
    }
  };

  const [activeContentTab, setActiveContentTab] = useState("normal");
  const [isPersonalizedLoading, setIsPersonalizedLoading] = useState(false);
  const isAdmin = checkIsAdmin();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const isReviewModeFromUrl = searchParams.get("review") === "true";
  const [audioUrl, setAudioUrl] = useState(audiourl);
  const utteranceQueueRef = useRef([]);
  const currentIndexRef = useRef(0);

  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [personalizedAudiourl, setPersonalizedAudiourl] = useState();
  const [loading, setLoading] = useState(false);
  const [isSuccessPopup, setIsSuccessPopup] = useState(false);
  const [showContentQuizPopup, setShowContentQuizPopup] = useState(false);
  const [quizViewMode, setQuizViewMode] = useState(false);

  const isContentQuizEnabled = (() => {
    const targetObj = Array.isArray(contentData) ? contentData[0] : contentData;
    if (targetObj && targetObj.is_content_quiz_enabled !== undefined) {
      return targetObj.is_content_quiz_enabled;
    }
    return true;
  })();

  // Auto-open quiz popup when user marks content as complete
  useEffect(() => {
    if (
      isMarkAsComplete &&
      activeComponent === "content" &&
      !isAdmin &&
      !isInstitution &&
      isContentQuizEnabled &&
      contentQuizData &&
      Array.isArray(contentQuizData?.[0]?.question) &&
      contentQuizData[0].question.length > 0 &&
      !contentQuizData[0].content_quiz_completed
    ) {
      setQuizViewMode(false);
      setShowContentQuizPopup(true);
    }
  }, [
    isMarkAsComplete,
    contentQuizData,
    activeComponent,
    isAdmin,
    isInstitution,
    isContentQuizEnabled,
  ]);

  const cleanText = (text) => {
    if (!text) return "";

    return text
      .replace(/[#*_`>-]/g, "")
      .replace(/–|—/g, "-")
      .replace(/[^a-zA-Z0-9\s\-.,!?;:'"()]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const splitTextSmart = (text, maxLength = 180) => {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    words.forEach((word) => {
      if ((currentChunk + word).length > maxLength) {
        if (currentChunk) chunks.push(currentChunk.trim());
        currentChunk = word + " ";
      } else {
        currentChunk += word + " ";
      }
    });

    if (currentChunk.trim()) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  };

  const stopSpeech = () => {
    window.speechSynthesis.cancel();
    utteranceQueueRef.current = [];
    currentIndexRef.current = 0;

    setIsSpeaking(false);
    setIsPaused(false);
  };

  const playChunks = () => {
    const synth = window.speechSynthesis;

    if (currentIndexRef.current >= utteranceQueueRef.current.length) {
      stopSpeech();
      return;
    }

    const chunk = utteranceQueueRef.current[currentIndexRef.current];
    const utterance = new SpeechSynthesisUtterance(chunk);

    utterance.onend = () => {
      currentIndexRef.current += 1;
      playChunks();
    };

    utterance.onerror = (err) => {
      console.error("Utterance error:", err);
      stopSpeech();
    };

    synth.speak(utterance);
  };

  const handleGenerateAudio = async (layer, id) => {
    setLoading(true);
    if (!id || !layer) {
      setLoading(false);
      return;
    }

    try {
      const token = Cookies.get("accessToken");

      const response = await generatePersonlizedContentAudiobook(
        layer,
        id,
        token,
      );

      if (response?.status === "completed" || response?.type === "audio") {
        setIsSuccessPopup(true);
      }
    } catch (error) {
      console.error("Failed to generate audiobook:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePlayPause = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (activeContentTab === "personalized" && !personalizedAudiourl) {
      const title = pageTitle.toLowerCase();
      const id = activeId;
      handleGenerateAudio(title, id);
    }

    const textRaw = audioUrl;
    if (!textRaw) return;

    const synth = window.speechSynthesis;

    if (synth.getVoices().length === 0) {
      synth.onvoiceschanged = () => handlePlayPause(e);
      return;
    }

    if (isPaused) {
      synth.resume();
      setIsPaused(false);
      setIsSpeaking(true);
      return;
    }

    if (isSpeaking && !isPaused) {
      synth.pause();
      setIsPaused(true);
      setIsSpeaking(false);
      return;
    }

    try {
      const clean = cleanText(textRaw);
      if (!clean) return;

      const chunks = splitTextSmart(clean);

      utteranceQueueRef.current = chunks;
      currentIndexRef.current = 0;

      synth.cancel();
      playChunks();

      setIsSpeaking(true);
      setIsPaused(false);
    } catch (err) {
      console.error("TTS error:", err);
      stopSpeech();
    }
  };

  useEffect(() => {
    setIsSpeaking(false);
    return () => {
      window.speechSynthesis.cancel();
    };
  }, [audioUrl]);

  useEffect(() => {
    const tabFromUrl = searchParams.get("contentTab");
    if (tabFromUrl === "normal" || tabFromUrl === "personalized") {
      setActiveContentTab(tabFromUrl);
    }
  }, [searchParams]);

  const handleContentTabChange = (e, v) => {
    setActiveContentTab(v);
    const nextParams = new URLSearchParams(location.search);
    nextParams.set("contentTab", v);
    navigate(`${location.pathname}?${nextParams.toString()}`, {
      replace: true,
    });
  };

  useEffect(() => {
    try {
      const storedUser = Cookies.get("user");
      if (storedUser) {
        const parsed = JSON.parse(storedUser);
        setIsPremium(parsed?.premium === true);
      }
    } catch (e) {
      setIsPremium(false);
    }
  }, []);

  useEffect(() => {
    if (isReviewModeFromUrl || isAdmin) {
      setShowSolutions(true);
      setIsTestSubmitted(false);
    }
  }, [isReviewModeFromUrl, isAdmin]);
  useEffect(() => {
    const fetchExistingQuizResult = async () => {
      if (
        activeId &&
        pageTitle &&
        pageKey &&
        [
          "quiz",
          "mcq",
          "match",
          "truefalse",
          "trueorfalse",
          "fillups",
        ].includes(activeComponent?.toLowerCase())
      ) {
        try {
          setResultsLoading(true);
          const result = await getQuizResult({
            title: pageTitle,
            key: pageKey,
            quiz_page_content_id: activeId,
          });
          if (
            result &&
            (result.submitted ||
              result.completed ||
              result[0].completed ||
              result.data?.completed)
          ) {
            const resData =
              result.data ||
              (Array.isArray(result) ? result[0]?.data || result[0] : result);
            const finalScore =
              resData.no_of_question_correct !== undefined &&
              resData.total_questions > 0
                ? Math.round(
                    (resData.no_of_question_correct / resData.total_questions) *
                      100,
                  )
                : resData.score || 0;

            setScore(finalScore);
            setIsTestSubmitted(true);

            if (resData.attempt_data && Array.isArray(resData.attempt_data)) {
              const newAnswers = {};
              resData.attempt_data.forEach((item) => {
                let userAnswerVal = item.user_answer;
                if (item.type === "trueorfalse" || item.type === "truefalse") {
                  if (item.user_answer?.toLowerCase() === "true")
                    userAnswerVal = "A";
                  else if (item.user_answer?.toLowerCase() === "false")
                    userAnswerVal = "B";
                }

                const isQuizType = [
                  "quiz",
                  "mcq",
                  "truefalse",
                  "trueorfalse",
                  "fillups",
                  "match",
                ].includes(item.type?.toLowerCase());

                const ansObj = isQuizType
                  ? { value: userAnswerVal, isSubmitted: true }
                  : userAnswerVal;

                if (item.question) newAnswers[item.question] = ansObj;
                if (item.question_id) newAnswers[item.question_id] = ansObj;
              });
              if (typeof setMcqAnswers === "function") {
                setMcqAnswers(newAnswers);
              }
            }
          }
        } catch (error) {
          console.error("Error fetching existing quiz result:", error);
        } finally {
          setResultsLoading(false);
        }
      }
      setLastCheckedId(activeId);
    };

    const isCurrentlyCompleted = (() => {
      if (!completed || !activeId) return false;

      const checkList = (list) => {
        if (!Array.isArray(list)) return false;
        for (const item of list) {
          const itemId =
            typeof item.page === "object"
              ? item.page?._id || item.page?.id
              : item.page;
          if (String(itemId) === String(activeId)) {
            if (
              activeComponent === "test"
            ) {
              return isAdmin ? item.completed : item.completed && item.content_quiz_completed;
            }
            return item.completed;
          }

          if (Array.isArray(item.child_pages)) {
            const childMatch = item.child_pages.find((child) => {
              const childPageId =
                typeof child.page === "object"
                  ? child.page?._id || child.page?.id
                  : child.page;
              return String(childPageId) === String(activeId);
            });
            if (childMatch) {
              if (
                activeComponent === "test"
              ) {
                return isAdmin ? childMatch.completed : childMatch.completed && childMatch.content_quiz_completed;
              }
              return childMatch.completed;
            }
          }
        }
        return false;
      };

      const result =
        checkList(completed.data) || checkList(completed.active_recall);
      return result;
    })();

    setIsPageCompleted(isCurrentlyCompleted);

    if (
      isCurrentlyCompleted &&
      activeComponent === "active_recall_test" &&
      activeId &&
      pageTitle &&
      pageKey
    ) {
      const fetchActiveRecallStatus = async () => {
        try {
          const res = await getActiveRecallCompletedApi({
            title: pageTitle,
            key: pageKey,
            active_recall_id: activeId,
          });
          const resData = res?.data || res;
          if (resData && resData.completed) {
            const summary = resData || {};
            const totalQuestions = summary.total_questions || 0;
            const correct = summary.no_of_question_correct || 0;
            const attempted = summary.no_of_questions_attempted || 0;

            let percentage = summary.score || 0;
            if (!percentage && totalQuestions > 0) {
              percentage = Math.round((correct / totalQuestions) * 100);
            }
            if (!percentage && attempted > 0) {
              percentage = Math.round((correct / attempted) * 100);
            }

            setScore(percentage);
            setTestResult({
              completed: true,
              percentage,
              summary,
            });
          }
        } catch (error) {
          console.error("Error fetching active recall status:", error);
        }
      };
      fetchActiveRecallStatus();
    }

    const isQuizComponent = [
      "quiz",
      "mcq",
      "match",
      "truefalse",
      "trueorfalse",
      "fillups",
    ].includes(activeComponent?.toLowerCase());

    if (isQuizComponent && !isTestSubmitted && lastCheckedId !== activeId) {
      fetchExistingQuizResult();
    } else if (!isCurrentlyCompleted && !isQuizComponent) {
      setIsTestSubmitted(false);
      setScore(0);
    }

    if (lastCheckedId !== activeId && isTestSubmitted) {
      setLastCheckedId(activeId);
    }
  }, [
    activeId,
    pageTitle,
    pageKey,
    completed,
    activeComponent,
    isTestSubmitted,
    lastCheckedId,
    setMcqAnswers,
  ]);

  const getIdentifier = (item) => {
    if (!item) return null;
    let idVal = item.id || item._id;
    if (idVal && typeof idVal === "object" && idVal.$oid) {
      return idVal.$oid;
    }
    if (typeof idVal === "string") {
      return idVal;
    }
    return null;
  };

  const parsePersonalizedResponse = (response) => {
    const root = response?.data || response;
    let data = root?.data || root;
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (e) {
        // ignore
      }
    }
    return data;
  };

  const fetchPersonalized = async () => {
    try {
      let response;
      const params = { id: activeId };

      const title = (pageTitle || "subtopic").toLowerCase();
      if (title === "course") {
        response = await getCoursePersonalizedContent(params);
      } else if (title === "subject") {
        response = await getSubjectPersonalizedContent(params);
      } else if (title === "topic") {
        response = await getTopicPersonalizedContent(params);
      } else {
        response = await getSubtopicPersonalizedContent(params);
      }

      const data = parsePersonalizedResponse(response);
      let content = "";

      if (data) {
        const item = Array.isArray(data) ? data[0] : data;
        if (item) {
          const extractedId = getIdentifier(item);
          setPersonalizedContentId(extractedId);
          setPersonalizedAudiourl(item.tts_s3_url);
          if (typeof item.content === "string") {
            content = item.content;
          } else if (typeof item.structured === "string") {
            content = item.structured;
          } else if (Array.isArray(item) && item[0]?.content) {
            if (typeof item[0].content === "string") {
              content = item[0].content;
            }
          }
        }
      }

      if (typeof content === "string" && content.trim()) {
        setPersonalizedContentData(content);
      }
    } catch (error) {
      console.error("Error fetching personalized content:", error);
    }
  };
  useEffect(() => {
    setPersonalizedContentData(null);
    setPersonalizedContentId(null);
    setActiveContentTab("normal");
    setIsReattempting(false);

    if (!activeId) return;

    if (activeComponent !== "content") return;

    fetchPersonalized();
  }, [
    activeId,
    pageTitle,
    pageKey,
    selectedCourse,
    isSuccessPopup,
    activeComponent,
  ]);

  useEffect(() => {
    if (activeContentTab === "personalized") {
      setAudioUrl(personalizedAudiourl);
    } else {
      setAudioUrl(audiourl);
    }
  }, [activeContentTab, isSuccessPopup, audiourl, personalizedAudiourl]);

  const MixedContentItem = ({
    item,
    pageName,
    onNext,
    onPrev,
    isLastItem,
    isFirstItem,
    onSubmit,
    answers,
    setAnswers,
    handleCompletedClick,
    activeComponent,
    isAdmin,
    isMaterialItem,
    mode = "quiz",
  }) => {
    const [current, setCurrent] = useState(0);

    const type = item.type?.toLowerCase();

    const isTest = pageName?.toLowerCase().includes("test");

    let parsedContent;
    if (type === "content" || type === "active_recall_content") {
      if (typeof item.content === "string") {
        try {
          const parsed = JSON.parse(item.content);
          if (Array.isArray(parsed)) {
            parsedContent = parsed;
          } else if (typeof parsed === "object" && parsed !== null) {
            parsedContent = [parsed];
          } else {
            parsedContent = [{ content: item.content, type: "content" }];
          }
        } catch (e) {
          parsedContent = [{ content: item.content, type: "content" }];
        }
      } else {
        parsedContent = Array.isArray(item.content)
          ? item.content
          : [item.content];
      }
    } else {
      parsedContent = parseContent(item.content || item);
    }

    let component;
    let hasInternalNav = false;

    switch (type) {
      case "match":
        component = (
          <Match
            data={parsedContent?.questions?.[0] || parsedContent}
            mode={mode}
            answers={answers}
            setAnswers={setAnswers}
            questionId={item.id}
            isAdmin={isAdmin}
            hideQuestionSubmit={mode === "quiz"}
          />
        );
        break;
      case "trueorfalse":
      case "truefalse":
        component = (
          <TrueFalse
            questions={parsedContent?.questions || [parsedContent]}
            current={current}
            setCurrent={setCurrent}
            answers={answers}
            setAnswers={setAnswers}
            onNext={!isLastItem ? onNext : undefined}
            onPrev={!isFirstItem ? onPrev : undefined}
            mode={mode}
            isAdmin={isAdmin}
            hideQuestionSubmit={mode === "quiz"}
          />
        );
        break;
      case "mcq":
      case "quiz":
        component = (
          <MCQ
            questions={parsedContent?.questions || [parsedContent]}
            current={current}
            setCurrent={setCurrent}
            answers={answers}
            setAnswers={setAnswers}
            pageName={pageName}
            onNext={!isLastItem ? onNext : undefined}
            onPrev={!isFirstItem ? onPrev : undefined}
            mode={mode}
            isAdmin={isAdmin}
          />
        );
        break;
      case "analysis":
      case "conversation":
        const analysisQuestion =
          parsedContent?.questions?.[0]?.question ||
          parsedContent?.question ||
          "Analyze this topic.";
        component = (
          <ConversationalAnalysis question={analysisQuestion} onNext={onNext} />
        );
        break;
      case "fillups":
        component = (
          <Fillups
            questions={
              parsedContent?.questions ||
              parsedContent?.originalItem?.content?.questions || [parsedContent]
            }
            current={current}
            setCurrent={setCurrent}
            answers={answers}
            setAnswers={setAnswers}
            onNext={!isLastItem ? onNext : undefined}
            onPrev={!isFirstItem ? onPrev : undefined}
            mode={mode}
            isAdmin={isAdmin}
          />
        );
        break;
      case "materials":
      case "material_item":
        return (
          <div className="content-page">
            <MaterialsRenderer content={parsedContent} />
          </div>
        );
      default:
        component = (
          <>
            <Content
              content={
                personalizedContentData && activeContentTab === "personalized"
                  ? [
                      {
                        type: "content",
                        content: personalizedContentData,
                      },
                    ]
                  : parsedContent
              }
              handleCompletedClick={handleCompletedClick}
              isMarkAsComplete={isMarkAsComplete}
              setIsMarkAsComplete={setIsMarkAsComplete}
            />
          </>
        );
    }

    return (
      <div
        className="mixed-item-container custom-scrollbar"
        style={{
          width: "100%",
          height:
            activeComponent === "quiz"
              ? "calc(100dvh - 186px)"
              : "calc(100dvh - 210px)",
        }}
      >
        <div
          className="mixed-item-content custom-scrollbar"
          style={{ height: "100%" }}
        >
          {component}
        </div>
        {!hasInternalNav && type !== "content" && !isMaterialItem && (
          <div className="mixed-item-nav">
            <button
              onClick={onPrev}
              disabled={isFirstItem}
              className={`nav-btn prev ${isFirstItem ? "disabled" : ""}`}
            >
              Previous
            </button>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={onNext}
                className={`nav-btn next ${isLastItem ? "disabled" : ""}`}
                disabled={isLastItem}
              >
                Next
              </button>
              {(isTest || isLastItem) && !isAdmin && !showSolutions && (
                <button onClick={onSubmit} className="nav-btn btn-submit">
                  Submit
                </button>
              )}
              {showSolutions && (
                <button
                  onClick={() => {
                    setIsTestSubmitted(true);
                    setShowSolutions(false);
                  }}
                  className="nav-btn"
                  style={{
                    background: "var(--color-primary)",
                    padding: "8px 20px",
                    borderRadius: "8px",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Back to Results
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const getQuestionHeading = (type) => {
    const map = {
      mcq: "Multiple Choice Questions",
      trueorfalse: "True or False",
      match: "Match the Following",
      analysis: "Conversational Analysis",
      fillups: "Fill in the Blanks",
    };
    return map[type?.toLowerCase()] || "Questions";
  };

  const getCategoryLabel = (category) => {
    const map = {
      application: "Application",
      reasoning: "Reasoning",
      direct: "Direct",
      critical_thinking: "Critical Thinking",
    };
    return (
      map[category?.toLowerCase().replaceAll("_", "")] ||
      category.replaceAll("_", "")
    );
  };

  const getCategoryIcon = (category) => {
    const iconMap = {
      application: "/assets/images/applicationImg.svg",
      direct: "/assets/images/directImg.svg",
      reasoning: "/assets/images/reasoningImg.svg",
      critical_thinking: "/assets/images/criticalThinkingImg.svg",
    };
    const iconSrc = iconMap[category?.toLowerCase()];
    return iconSrc ? (
      <img src={iconSrc} alt={category} className="category-icon" />
    ) : null;
  };

  useEffect(() => {
    setIsTestSubmitted(false);
    setScore(0);
    setInternalMixedIndex(0);
    setTestResult(null);
    setTestPageData(null);
    setShowAiTutor(false);
    setShowSolutions(false);

    if (
      activeComponent === "test" ||
      activeComponent === "active_recall_test"
    ) {
      const fetchTestData = async () => {
        try {
          setTestPageLoading(true);
          const params = {
            title: pageTitle || pageName || "subtopic",
            key: pageKey || selectedCourse?.key,
            test_page_content_id: activeId,
          };

          const res = await getTestData(params);
          // API returns [{completed, data:{...}, test_completion_coins, test_completion_xp}]
          const first = Array.isArray(res) ? res[0] : res;
          const data = first?.data || res;
          setTestPageData(data || null);

          // Read rewards directly from the API response — no cookie needed
          if (first && first.completed) {
            const coins =
              typeof first.test_completion_coins === "number"
                ? first.test_completion_coins
                : null;
            const xp =
              typeof first.test_completion_xp === "number"
                ? first.test_completion_xp
                : null;
            setLastTestRewards(
              coins !== null || xp !== null
                ? { coins: coins ?? 0, xp: xp ?? 0 }
                : null,
            );
          } else {
            setLastTestRewards(null);
          }

          if (activeComponent === "active_recall_test") {
            // Active recall tests track completion separately — fetch from dedicated API
            if (activeId && pageTitle && pageKey) {
              try {
                const arRes = await getActiveRecallCompletedApi({
                  title: pageTitle,
                  key: pageKey,
                  active_recall_id: activeId,
                });
                const arData = arRes?.data || arRes;
                if (arData && arData.completed) {
                  const summary = arData || {};
                  const totalQuestions = summary.total_questions || 0;
                  const correct = summary.no_of_question_correct || 0;
                  const attempted = summary.no_of_questions_attempted || 0;

                  let percentage = summary.score || 0;
                  if (!percentage && totalQuestions > 0) {
                    percentage = Math.round((correct / totalQuestions) * 100);
                  }
                  if (!percentage && attempted > 0) {
                    percentage = Math.round((correct / attempted) * 100);
                  }

                  setScore(percentage);
                  setTestResult({
                    completed: true,
                    percentage,
                    summary,
                  });
                }
              } catch (arError) {
                console.error(
                  "Error fetching active recall completed status:",
                  arError,
                );
              }
            }
          } else if (data && data?.completed) {
            // Regular test — use data returned by getTestData
            const summary = data || {};
            const totalQuestions = summary.total_questions || 0;
            const correct = summary.no_of_question_correct || 0;
            const attempted = summary.no_of_questions_attempted || 0;

            let percentage =
              typeof summary.pass_percentage === "number"
                ? summary.pass_percentage
                : 0;

            if (!percentage) {
              if (totalQuestions > 0) {
                percentage = Math.round((correct / totalQuestions) * 100);
              } else if (attempted > 0) {
                percentage = Math.round((correct / attempted) * 100);
              }
            }

            setTestResult({
              completed: true,
              percentage,
              summary,
            });
          }
        } catch (error) {
          console.error("Error fetching test data in RenderPage:", error);
          setTestPageData(null);
        } finally {
          setTestPageLoading(false);
        }
      };

      fetchTestData();
    } else {
      setTestPageLoading(false);
    }

    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [
    activeId,
    contentData,
    activeComponent,
    pageKey,
    pageTitle,
    selectedCourse?.key,
    pageName,
  ]);

  const buildUserData = (testResultData) => {
    if (!testResultData || !testResultData.questions || !testResultData.answers)
      return [];

    const { questions, answers } = testResultData;

    const buildOptions = (questionObj) => {
      if (!questionObj) return [];

      if (Array.isArray(questionObj.options)) {
        const letters = ["A", "B", "C", "D", "E", "F"];
        return questionObj.options.map((opt, idx) => {
          const key = letters[idx] || String(idx + 1);
          if (typeof opt === "string") {
            return { [key]: opt };
          }
          if (opt && typeof opt === "object") {
            const letterKey = Object.keys(opt).find((k) =>
              ["A", "B", "C", "D", "E", "F"].includes(k),
            );
            let text;
            if (letterKey) {
              text = opt[letterKey];
            } else {
              text = opt.text || opt.label || opt.value || opt.option || "";
            }
            return { [key]: text };
          }
          return { [key]: String(opt) };
        });
      }

      const letters = ["A", "B", "C", "D", "E", "F"];
      const collected = letters
        .filter(
          (key) =>
            Object.prototype.hasOwnProperty.call(questionObj, key) &&
            questionObj[key] !== undefined &&
            questionObj[key] !== null &&
            String(questionObj[key]).trim() !== "",
        )
        .map((key) => ({ [key]: questionObj[key] }));

      return collected;
    };

    return questions?.reduce((acc, q) => {
      let content = q.content;
      try {
        if (typeof content === "string") {
          content = JSON.parse(content);
        }
        if (typeof content === "string") {
          content = JSON.parse(content);
        }
      } catch (e) {
        return acc;
      }

      const type = (q.type || "").toLowerCase().trim();
      const questionObj =
        type === "match" ? content : content?.questions?.[0] || content;
      if (!questionObj) return acc;

      const questionId =
        questionObj.question_id || q.sequence || questionObj.question;
      const rawUserAnswer = answers[questionId];
      if (!rawUserAnswer) return acc;

      const correctAnswer =
        questionObj.correct_answer || questionObj.answer || "";
      const userValue =
        rawUserAnswer &&
        typeof rawUserAnswer === "object" &&
        "value" in rawUserAnswer
          ? rawUserAnswer.value
          : rawUserAnswer;

      if (
        userValue === undefined ||
        userValue === null ||
        String(userValue).trim() === ""
      ) {
        return acc;
      }

      let isCorrect = false;

      if (
        type === "mcq" ||
        type === "quiz" ||
        type === "trueorfalse" ||
        type === "truefalse"
      ) {
        const normUser = String(userValue).trim().toLowerCase();
        const normCorrect = String(correctAnswer).trim().toLowerCase();
        isCorrect = normUser === normCorrect;
      } else if (type === "fillups") {
        const normUser = String(userValue || "")
          .trim()
          .toLowerCase();
        const normCorrect = String(correctAnswer || "")
          .trim()
          .toLowerCase();
        isCorrect = normUser === normCorrect;
      } else {
        return acc;
      }

      if (isCorrect) return acc;

      const options = buildOptions(questionObj);

      acc.push({
        question: questionObj.question || "",
        options,
        answer: correctAnswer,
        user_answer: userValue,
        explanation: questionObj.explanation || "",
      });

      return acc;
    }, []);
  };

  // const handlePlayPause = async (e) => {
  //   if (!audioRef.current || !audioUrl) {
  //     setAudioUrl(audiourl);
  //   }
  //   e.stopPropagation();
  //   if (isSpeaking) {
  //     audioRef.current.pause();
  //     setIsSpeaking(false);
  //   } else {
  //     audioRef?.current?.play();
  //     setIsSpeaking(true);
  //   }
  // };

  const handleTeachClick = async () => {
    setShowAiTutor(true);

    if (aiLessons || aiLoading) {
      return;
    }

    try {
      setAiLoading(true);
      setAiError(null);
      const user_data =
        (testResult &&
          testResult.summary &&
          Array.isArray(testResult.summary.attempt_data) &&
          testResult.summary.attempt_data.length > 0 &&
          testResult.summary.attempt_data) ||
        buildUserData(testResult);

      const response = await sendAiTutorData(
        { user_data },
        {
          testPageId: activeId,
          title: pageTitle,
          key: pageKey || selectedCourse?.key,
        },
      );

      if (response && response.id) {
        setAiTutorContentId(response.id);
      }

      let lessonsFromApi = [];

      if (response?.raw) {
        try {
          const parsedRaw =
            typeof response.raw === "string"
              ? JSON.parse(response.raw)
              : response.raw;
          if (Array.isArray(parsedRaw?.data)) {
            lessonsFromApi = parsedRaw.data;
          }
        } catch (e) {
          console.error("Failed to parse raw field:", e);
        }
      }

      if (
        (!lessonsFromApi || lessonsFromApi.length === 0) &&
        response?.structured
      ) {
        lessonsFromApi = response.structured.data ?? [];
      }

      if (
        (!lessonsFromApi || lessonsFromApi.length === 0) &&
        response?.content
      ) {
        try {
          if (Array.isArray(response.content)) {
            lessonsFromApi = response.content;
          } else if (typeof response.content === "string") {
            const parsedContent = JSON.parse(response.content);
            if (Array.isArray(parsedContent)) {
              lessonsFromApi = parsedContent;
            } else if (Array.isArray(parsedContent?.content)) {
              lessonsFromApi = parsedContent.content;
            }
          }
        } catch (e) {
          console.error("Failed to parse content field:", e);
        }
      }

      if (!Array.isArray(lessonsFromApi) || lessonsFromApi.length === 0) {
        setAiLessons([]);
        setAiError("No AI tutor lessons returned from server.");
      } else {
        const sorted = [...lessonsFromApi].sort(
          (a, b) => (a.sequence || 0) - (b.sequence || 0),
        );
        setAiLessons(sorted);
      }
    } catch (error) {
      console.error("Error in AI Tutor:", error);
      setAiError("Failed to load AI tutor content.");
      setAiLessons([]);
    } finally {
      setAiLoading(false);
    }
  };

  const handleRegenerateAiTutor = async () => {
    try {
      setAiLoading(true);
      setAiError(null);
      const user_data =
        (testResult &&
          testResult.summary &&
          Array.isArray(testResult.summary.attempt_data) &&
          testResult.summary.attempt_data.length > 0 &&
          testResult.summary.attempt_data) ||
        buildUserData(testResult);

      const response = await sendAiTutorData(
        { user_data },
        {
          testPageId: activeId,
          title: pageTitle,
          key: pageKey || selectedCourse?.key,
          regenerate: true,
        },

      );

      if (response && response.id) {
        setAiTutorContentId(response.id);
      }

      let lessonsFromApi = [];

      if (response?.raw) {
        try {
          const parsedRaw =
            typeof response.raw === "string"
              ? JSON.parse(response.raw)
              : response.raw;
          if (Array.isArray(parsedRaw?.data)) {
            lessonsFromApi = parsedRaw.data;
          }
        } catch (e) {
          console.error("Failed to parse raw field:", e);
        }
      }

      if (
        (!lessonsFromApi || lessonsFromApi.length === 0) &&
        response?.structured
      ) {
        lessonsFromApi = response.structured.data ?? [];
      }

      if (
        (!lessonsFromApi || lessonsFromApi.length === 0) &&
        response?.content
      ) {
        try {
          if (Array.isArray(response.content)) {
            lessonsFromApi = response.content;
          } else if (typeof response.content === "string") {
            const parsedContent = JSON.parse(response.content);
            if (Array.isArray(parsedContent)) {
              lessonsFromApi = parsedContent;
            } else if (Array.isArray(parsedContent?.content)) {
              lessonsFromApi = parsedContent.content;
            }
          }
        } catch (e) {
          console.error("Failed to parse content field:", e);
        }
      }

      if (!Array.isArray(lessonsFromApi) || lessonsFromApi.length === 0) {
        setAiLessons([]);
        setAiError("No AI tutor lessons returned from server.");
      } else {
        const sorted = [...lessonsFromApi].sort(
          (a, b) => (a.sequence || 0) - (b.sequence || 0),
        );
        setAiLessons(sorted);
      }
    } catch (error) {
      console.error("Error in AI Tutor regeneration:", error);
      setAiError("Failed to load AI tutor content.");
      setAiLessons([]);
    } finally {
      setAiLoading(false);
    }
  };


  const mixedCurrentIndex =
    propMixedIndex !== undefined ? propMixedIndex : internalMixedIndex;
  const setMixedCurrentIndex = propSetMixedIndex || setInternalMixedIndex;

  const processedContentData = useMemo(() => {
    let rawData = overrideContentData || contentData;

    const quizTypes = [
      "quiz",
      "mcq",
      "trueorfalse",
      "truefalse",
      "fillups",
      "match",
      "analysis",
      "content",
      "test",
      "active_recall_test",
    ];

    if (rawData && !Array.isArray(rawData)) {
      if (
        quizTypes.includes(activeComponent?.toLowerCase()) ||
        rawData.questions ||
        rawData.type
      ) {
        rawData = [rawData];
      }
    }

    if (
      isAdmin &&
      (activeComponent === "test" ||
        activeComponent === "active_recall_test") &&
      testPageData
    ) {
      rawData = testPageData.questions || testPageData.content || [];
    }

    if (!Array.isArray(rawData)) return [];

    const result = [];
    let currentGroup = null;

    rawData.forEach((item) => {
      const type = (item.type || activeComponent)?.toLowerCase();

      if (type === "content") {
        let itemContent = [];
        if (typeof item.content === "string") {
          try {
            const parsed = JSON.parse(item.content);
            if (Array.isArray(parsed)) itemContent = parsed;
            else if (typeof parsed === "object" && parsed !== null)
              itemContent = [parsed];
            else itemContent = [{ content: item.content, type: "content" }];
          } catch {
            itemContent = [{ content: item.content, type: "content" }];
          }
        } else if (Array.isArray(item.content)) {
          itemContent = item.content;
        } else if (typeof item.content === "object" && item.content !== null) {
          itemContent = [item.content];
        } else {
          itemContent = [{ content: item.content, type: "content" }];
        }

        if (currentGroup) {
          currentGroup.content = [...currentGroup.content, ...itemContent];
        } else {
          currentGroup = {
            ...item,
            content: itemContent,
            type: "content",
          };
          result.push(currentGroup);
        }
      } else if (
        ["mcq", "quiz", "truefalse", "trueorfalse", "fillups"].includes(type)
      ) {
        currentGroup = null;
        const parsed = parseContent(item.content || item);
        let questions = [];
        if (Array.isArray(parsed)) questions = parsed;
        else if (parsed?.questions) questions = parsed.questions;
        else if (parsed) questions = [parsed];

        questions.forEach((q) => {
          if (q) {
            result.push({
              ...q,
              type: type === "quiz" ? q.type || "mcq" : type,
              originalItem: item,
            });
          }
        });
      } else {
        currentGroup = null;
        result.push({ ...item, type: item.type || type });
      }
    });
    return result;
  }, [
    contentData,
    overrideContentData,
    isAdmin,
    activeComponent,
    testPageData,
  ]);

  const handleGeneratePersonalizedContent = async () => {
    if (!activeId) return;

    if (activeComponent !== "content") return;

    try {
      setIsPersonalizedLoading(true);
      if (personalizedContentId) {
        setContentEvals((prev) => {
          const copy = { ...prev };
          delete copy[personalizedContentId];
          return copy;
        });
      }
      const token = Cookies.get("accessToken");
      let response;
      const title = (pageTitle || "subtopic").toLowerCase();

      if (title === "course") {
        response = await generateCoursePersonalizedContent(activeId, token);
      } else if (title === "subject") {
        response = await generateSubjectPersonalizedContent(activeId, token);
      } else if (title === "topic") {
        response = await generateTopicPersonalizedContent(activeId, token);
      } else {
        response = await generateSubtopicPersonalizedContent(activeId, token);
      }

      const data = response?.data || response;
      let generatedContent = "";

      if (data) {
        if (typeof data.content === "string") {
          generatedContent = data.content;
        } else if (typeof data.structured === "string") {
          generatedContent = data.structured;
        }
      }

      if (typeof generatedContent === "string" && generatedContent.trim()) {
        setPersonalizedContentData(generatedContent);
        setActiveContentTab("personalized");

        const key =
          title === "course" ? selectedCourse?.key || pageKey : pageKey;

        const typeField =
          title === "course" || title === "subject" || title === "topic"
            ? title
            : "subtopic";

        const payload = {
          [typeField]: key,
          page_id: activeId,
          content: generatedContent,
        };

        if (typeField === "course") {
          await createCoursePersonalizedContent(payload);
        } else if (typeField === "subject") {
          await createSubjectPersonalizedContent(payload);
        } else if (typeField === "topic") {
          await createTopicPersonalizedContent(payload);
        } else {
          await createSubtopicPersonalizedContent(payload);
        }

        try {
          const getParams = { id: activeId };
          let getResponse;

          if (typeField === "course") {
            getResponse = await getCoursePersonalizedContent(getParams);
          } else if (typeField === "subject") {
            getResponse = await getSubjectPersonalizedContent(getParams);
          } else if (typeField === "topic") {
            getResponse = await getTopicPersonalizedContent(getParams);
          } else {
            getResponse = await getSubtopicPersonalizedContent(getParams);
          }

          const data = parsePersonalizedResponse(getResponse);
          let latestContent = "";

          if (data) {
            const item = Array.isArray(data) ? data[0] : data;
            if (item) {
              const extractedId = getIdentifier(item);
              setPersonalizedContentId(extractedId);
              if (extractedId) {
                setContentEvals((prev) => {
                  const copy = { ...prev };
                  delete copy[extractedId];
                  return copy;
                });
                pollPersonalizedContentEval(extractedId);
              }
              if (typeof item.content === "string") {
                latestContent = item.content;
              } else if (typeof item.structured === "string") {
                latestContent = item.structured;
              }
            }
          }

          if (typeof latestContent === "string" && latestContent.trim()) {
            setPersonalizedContentData(latestContent);
            setActiveContentTab("personalized");
          }
        } catch (e) {
          console.error(
            "Error refreshing personalized content after create:",
            e,
          );
        }
      }
    } catch (error) {
      console.error("Error generating/saving personalized content:", error);
    } finally {
      setIsPersonalizedLoading(false);
    }
  };

  const handleNextItem = () => {
    if (mixedCurrentIndex < processedContentData.length - 1) {
      setMixedCurrentIndex(mixedCurrentIndex + 1);
    }
  };

  const handlePrevItem = () => {
    if (mixedCurrentIndex > 0) {
      setMixedCurrentIndex(mixedCurrentIndex - 1);
    }
  };

  const showTeachButton = activeComponent === "test" && !!testResult;

  const handleSubmitTest = async () => {
    let no_of_question_correct = 0;
    let no_of_questions_attempted = 0;
    let total_questions = 0;

    const attempt_data = [];

    const buildOptions = (questionObj) => {
      if (!questionObj) return [];
      if (Array.isArray(questionObj.options)) {
        const letters = ["A", "B", "C", "D", "E", "F"];
        return questionObj.options.map((opt, idx) => {
          const key = letters[idx] || String(idx + 1);
          if (typeof opt === "string") return { [key]: opt };
          if (opt && typeof opt === "object") {
            const letterKey = Object.keys(opt).find((k) =>
              ["A", "B", "C", "D", "E", "F"].includes(k),
            );
            let text = letterKey
              ? opt[letterKey]
              : opt.text || opt.label || opt.value || opt.option || "";
            return { [key]: text };
          }
          return { [key]: String(opt) };
        });
      }
      const letters = ["A", "B", "C", "D", "E", "F"];
      const collected = letters
        .filter(
          (key) =>
            Object.prototype.hasOwnProperty.call(questionObj, key) &&
            questionObj[key] !== undefined &&
            questionObj[key] !== null &&
            String(questionObj[key]).trim() !== "",
        )
        .map((key) => ({ [key]: questionObj[key] }));

      return collected;
    };

    processedContentData.forEach((item) => {
      const type = item.type?.toLowerCase();

      if (type === "match") {
        let parsedContent = item.content;
        if (typeof parsedContent === "string") {
          try {
            parsedContent = JSON.parse(parsedContent);
          } catch (e) {
            parsedContent = [];
          }
        }

        let pairsData = [];
        if (Array.isArray(parsedContent)) {
          pairsData = parsedContent;
        } else if (parsedContent?.pairs) {
          pairsData = parsedContent.pairs;
        } else if (parsedContent?.questions) {
          pairsData = parsedContent.questions;
        }

        if (pairsData.length < 2) return;

        total_questions++;
        const questionId = item.id || item.question_id || item.question;
        const rawUserAnswer = mcqAnswers[questionId];
        const userAnswer =
          rawUserAnswer &&
          typeof rawUserAnswer === "object" &&
          "value" in rawUserAnswer
            ? rawUserAnswer.value
            : rawUserAnswer;

        if (userAnswer) {
          no_of_questions_attempted++;
        }

        let isCorrect = false;

        const leftCol = pairsData[0];
        const rightCol = pairsData[1];

        if (
          userAnswer &&
          Array.isArray(userAnswer) &&
          userAnswer.length >= 2 &&
          leftCol?.values &&
          rightCol?.values
        ) {
          const userRightVals = userAnswer[1].values;
          const correctRightVals = rightCol.values;

          if (
            userRightVals.length === correctRightVals.length &&
            userRightVals.every((val, idx) => val === correctRightVals[idx])
          ) {
            isCorrect = true;
          }
        }

        if (isCorrect) {
          no_of_question_correct++;
        }

        attempt_data.push({
          question_id: questionId,
          question: item.question || "Match the following",
          type: "match",
          options: [],
          pairs: userAnswer || [],
          answer: rightCol?.values || [],
          explanation: item.explanation || "",
          user_answer: userAnswer || "",
          categories: item.categories || [],
        });
        return;
      }

      if (
        ["mcq", "quiz", "truefalse", "trueorfalse", "fillups"].includes(type)
      ) {
        let parsedContent;
        if (typeof item.content === "string") {
          try {
            parsedContent = JSON.parse(item.content);
          } catch (e) {
            parsedContent = {};
          }
        } else {
          parsedContent = item;
        }

        let questions = [];
        if (Array.isArray(parsedContent)) {
          questions = parsedContent;
        } else if (parsedContent?.questions) {
          questions = parsedContent.questions;
        } else if (parsedContent) {
          questions = [parsedContent];
        }

        questions?.forEach((q) => {
          if (!q) return;
          if (!q.question && !q.question_id) return;

          total_questions++;
          const questionId = q.question_id || q.question;
          const rawUserAnswer = mcqAnswers[questionId];
          const userAnswer =
            typeof rawUserAnswer === "object" && rawUserAnswer !== null
              ? rawUserAnswer.value
              : rawUserAnswer;

          if (userAnswer) {
            no_of_questions_attempted++;
          }

          let correctAnswer = q.correct_answer || q.answer;
          let displayCorrectAnswer = correctAnswer;
          let displayUserAnswer = userAnswer;

          if (type === "truefalse" || type === "trueorfalse") {
            const isCorrectTrue =
              correctAnswer === true ||
              correctAnswer === "A" ||
              String(correctAnswer).toLowerCase() === "true";
            const isUserTrue =
              userAnswer === "A" || String(userAnswer).toLowerCase() === "true";

            displayCorrectAnswer = isCorrectTrue ? "true" : "false";
            displayUserAnswer = userAnswer
              ? isUserTrue
                ? "true"
                : "false"
              : "";

            if (userAnswer && isCorrectTrue === isUserTrue) {
              no_of_question_correct++;
            }
          } else if (type === "fillups") {
            const normUser = String(userAnswer || "")
              .trim()
              .toLowerCase();
            const normCorrect = String(correctAnswer || "")
              .trim()
              .toLowerCase();
            if (userAnswer && normUser === normCorrect) {
              no_of_question_correct++;
            }
          } else {
            const normUser = String(userAnswer || "").toUpperCase();
            const normCorrect = String(correctAnswer || "").toUpperCase();
            if (userAnswer && normUser === normCorrect) {
              no_of_question_correct++;
            }
          }

          attempt_data.push({
            question_id: q.question_id || "",
            question: q.question || "",
            options: type === "mcq" || type === "quiz" ? buildOptions(q) : [],
            type: type,
            answer: displayCorrectAnswer,
            explanation: q.explanation || "",
            user_answer: displayUserAnswer || "",
            categories: q.categories || [],
          });
        });
      }
    });

    const calculatedScore =
      total_questions > 0
        ? Math.round((no_of_question_correct / total_questions) * 100)
        : 0;
    setScore(calculatedScore);
    setIsTestSubmitted(true);
    setIsReattempting(false);

    const payload = {
      attempt_data,
      no_of_questions_attempted,
      no_of_question_correct,
      total_questions,
    };

    try {
      if (activeComponent === "active_recall_test") {
        const params = {
          title: pageTitle || "subtopic",
          key: pageKey || selectedCourse?.key,
          active_recall_id: activeId,
          parent_id: parent,
        };
        await submitActiveRecallCompleted(params, payload);

        const res = await getActiveRecallCompletedApi({
          title: pageTitle || "subtopic",
          key: pageKey || selectedCourse?.key,
          active_recall_id: activeId,
        });
        if (res?.data?.completed) {
          setIsPageCompleted(true);
        }
        fetchQuizEvals();
        handleClick(true);
      } else {
        await submitQuizResults(payload, {
          quizPageId: activeId,
          title: pageTitle || "subtopic",
          key: pageKey,
          parent: parent,
        });
        setIsPageCompleted(true);
        fetchQuizEvals();
        if (onQuizSubmitSuccess) {
          onQuizSubmitSuccess();
        }
      }
    } catch (error) {
      console.error("Error submitting quiz results:", error);
    }
  };

  const renderScoreChart = () => {
    if (isAdmin) {
      return null;
    }
    return (
      <div className="score-container score-container--simple">
        <div className="score-chart-wrapper">
          <AnimatedCircularProgress score={score} />
        </div>

        <div className="score-actions">
          <button
            className="btn-reattempt"
            onClick={() => {
              setIsTestSubmitted(false);
              setIsPageCompleted(false);
              setIsReattempting(true);
              setMixedCurrentIndex(0);
              setScore(0);
              setMcqAnswers({});
              setShowSolutions(false);
            }}
          >
            Reattempt
          </button>
          <button
            className="btn-show-answer"
            onClick={() => {
              setIsTestSubmitted(false);
              setMixedCurrentIndex(0);
              setShowSolutions(true);
            }}
          >
            Show Answer
          </button>
        </div>

        {!isAdmin && (
          <>
            <div
              className="assistant-trigger"
              onClick={() => setShowAssistant(!showAssistant)}
            >
              <img
                src={edluminaLogo}
                height={45}
                className="assistant-image"
                alt="Edlumina logo"
              />
            </div>

            {showAssistant && (
              <div className="assistant-popup">
                <div className="assistant-header">
                  <h3>Ainstein</h3>
                  <button
                    className="close-btn"
                    onClick={() => setShowAssistant(false)}
                  >
                    <CloseIcon fontSize="small" />
                  </button>
                </div>
                <div className="assistant-body">
                  <ConversationalAnalysis
                    question="Welcome to Ainstein what is your doubt?"
                    contentConvo={true}
                    apiQueryParams={{
                      id: activeId,
                      key: pageKey,
                      title: pageTitle,
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
  };
  const handleClick = async (skipActiveRecall = false) => {
    if (
      !skipActiveRecall &&
      (activeComponent === "active_recall_content" ||
        activeComponent === "active_recall_test")
    ) {
      try {
        const params = {
          title: pageTitle || "subtopic",
          key: pageKey || selectedCourse?.key,
          active_recall_id: activeId,
          parent_id: parent,
        };
        const arResponse = await submitActiveRecallCompleted(params, {});

        if (activeComponent === "active_recall_test") {
          const res = await getActiveRecallCompletedApi({
            title: pageTitle || "subtopic",
            key: pageKey || selectedCourse?.key,
            active_recall_id: activeId,
          });
          if (res?.data?.completed) {
            setIsPageCompleted(true);
          }
        }
        handleCompletedClick({ data: arResponse });
        return;
      } catch (error) {
        console.error("Error submitting active recall completion:", error);
      }
    }
    handleCompletedClick();
  };

  const renderComponent = () => {
    if (isPageLocked && !isAdmin) {
      return (
        <div className="content-page">
          <div className="locked-page-container">
            <div className="locked-page-content">
              <img
                src={lockIcon}
                alt="Page Locked"
                style={{
                  width: "64px",
                  height: "64px",
                  marginBottom: "20px",
                  opacity: "0.6",
                }}
              />
              <h2
                style={{
                  color: "#666",
                  marginBottom: "10px",
                  fontSize: "24px",
                  fontWeight: "600",
                }}
              >
                Page is Locked
              </h2>
            </div>
          </div>
        </div>
      );
    }

    const quizTypes = [
      "quiz",
      "mcq",
      "truefalse",
      "trueorfalse",
      "fillups",
      "match",
    ];

    if (
      processedContentData.length > 0 &&
      (Array.isArray(contentData) ||
        quizTypes.includes(activeComponent?.toLowerCase()) ||
        isAdmin) &&
      ((activeComponent !== "test" &&
        activeComponent !== "active_recall_test") ||
        location.pathname.includes("/test/") ||
        isAdmin)
    ) {
      if (processedContentData.length === 0)
        return <div className="mcq-empty">No content available</div>;

      const currentItem = processedContentData[mixedCurrentIndex];
      const isLastItem = mixedCurrentIndex === processedContentData.length - 1;
      const isMaterialItem = processedContentData.some((item) =>
        [
          "material_item",
          "doc",
          "ppt",
          "pdf",
          "image",
          "mindmap",
          "video",
          "audio",
        ].includes(item.type?.toLowerCase()),
      );
      const isQuizPage = processedContentData.some((item) =>
        [
          "mcq",
          "quiz",
          "truefalse",
          "trueorfalse",
          "fillups",
          "match",
        ].includes(item.type?.toLowerCase()),
      );

      return (
        <div className="content-page-mixed custom-scrollbar">
          {resultsLoading && (isPageCompleted || isTestSubmitted) ? (
            <GlobalLoader />
          ) : (isTestSubmitted || (isPageCompleted && isQuizPage && activeComponent !== "test" && activeComponent !== "active_recall_test")) && !showSolutions && !isReattempting ? (
            renderScoreChart()
          ) : (
            <>
              <div className="mobile-page-header">
                <div className="mobile-header-top">
                  <div className="title-section">
                    {pageName && (
                      <TooltipComponent className="pagename-label">
                        {pageName}
                      </TooltipComponent>
                    )}
                    {currentItem.categories && (
                      <div className="question-category mobile-category-badge">
                        <span
                          className={`category-badge ${currentItem.categories
                            .toLowerCase()
                            .replaceAll("_", "")}`}
                        >
                          {getCategoryIcon(currentItem.categories)}
                          {getCategoryLabel(currentItem.categories)}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="mobile-header-actions">
                    {(audiourl || activeContentTab === "personalized") &&
                      (activeComponent === "content" ||
                        activeComponent === "active_recall_component") && (
                        <button
                          className="play-btn-small"
                          onClick={handlePlayPause}
                        >
                          {isSpeaking && !isPaused ? (
                            <PauseIcon />
                          ) : (
                            <PlayArrowIcon />
                          )}
                        </button>
                      )}
                    {activeContentTab === "personalized" && personalizedContentId && checkIsAiEvalEnabled() && !checkIsAdmin() && (
                      <div className="ai-eval-chip-wrapper" style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                        {contentEvals[personalizedContentId] ? (
                          <button
                            className="ps-row__aieval-chip evaluated"
                            onClick={handleAiEvalClick}
                            disabled={evalLoading}
                          >
                            Eval: {contentEvals[personalizedContentId].overall_score}/10
                          </button>
                        ) : (
                          <button
                            className={`ps-row__aieval-chip ${evalLoading ? 'loading' : ''}`}
                            onClick={handleAiEvalClick}
                            disabled={evalLoading}
                          >
                            {evalLoading ? "Evaluating..." : "Evaluate with AI"}
                          </button>
                        )}
                        <button
                          className="ps-row__aieval-chip regenerate"
                          onClick={handleGeneratePersonalizedContent}
                          disabled={isPersonalizedLoading}
                          title="Regenerate Personalized Content with AI"
                        >
                          {isPersonalizedLoading ? "Regenerating..." : "Regenerate"}
                        </button>
                      </div>
                    )}
                    {!isInstitution &&
                      (activeComponent === "content" ||
                        activeComponent === "active_recall" ||
                        activeComponent === "active_recall_content" ||
                        activeComponent === "active_recall_test" ||
                        isAdmin) && (
                        <div className="completion-actions">
                          <button
                            className={`mark-as-complete-btn ${
                              isPageCompleted ? "not-allowed" : ""
                            }`}
                            onClick={() => {
                              if (isPageCompleted) {
                                return;
                              }
                              handleClick();
                            }}
                          >
                            {isPageCompleted
                              ? `Completed`
                              : `Mark as Completed`}
                          </button>
                          {activeComponent === "content" &&
                            isPremium &&
                            !personalizedContentData && (
                              <button
                                className="mark-as-complete-btn"
                                onClick={handleGeneratePersonalizedContent}
                              >
                                Create customised content
                              </button>
                            )}
                        </div>
                      )}
                  </div>
                </div>

                {personalizedContentData &&
                  (activeComponent === "content" ||
                    activeComponent === "active_recall_content" ||
                    currentItem?.type?.toLowerCase() === "content") && (
                    <div className="mobile-header-tabs">
                      <Tabs
                        className="personalized-tabs"
                        value={activeContentTab}
                        onChange={handleContentTabChange}
                        textColor="primary"
                        indicatorColor="primary"
                      >
                        <Tab label="Predefined Content" value="normal" />
                        <Tab
                          label="Personalized Content"
                          value="personalized"
                        />
                      </Tabs>
                    </div>
                  )}
              </div>
              <header className="content-header" style={{ display: "block" }}>
                {currentItem.type?.toLowerCase() !== "content" &&
                  !isMaterialItem && (
                    <div
                      className="title-wrapper"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <div
                        className="main-title"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "20px",
                          fontWeight: "600",
                        }}
                      >
                        <span className="title-icon">
                          <PsychologyIcon />
                        </span>
                        {getQuestionHeading(currentItem.type)}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        {currentItem.categories && (
                          <div className="question-category desktop-question-category">
                            <span
                              className={`category-badge ${currentItem.categories
                                .toLowerCase()
                                .replaceAll("_", "")}`}
                            >
                              {getCategoryIcon(currentItem.categories)}
                              {getCategoryLabel(currentItem.categories)}
                            </span>
                          </div>
                        )}
                        <div className="content-progress">
                          Q{mixedCurrentIndex + 1} of{" "}
                          {processedContentData.length}
                        </div>
                      </div>
                    </div>
                  )}
              </header>
              {isMaterialItem ? (
                <div className="content-page">
                  <MaterialsRenderer content={contentData} />
                </div>
              ) : (
                <MixedContentItem
                  item={currentItem}
                  pageName={pageName}
                  onNext={handleNextItem}
                  onPrev={handlePrevItem}
                  isLastItem={isLastItem}
                  isFirstItem={mixedCurrentIndex === 0}
                  onSubmit={handleSubmitTest}
                  answers={mcqAnswers}
                  setAnswers={setMcqAnswers}
                  activeComponent={activeComponent}
                  isAdmin={isAdmin}
                  isMaterialItem={isMaterialItem}
                  mode={
                    showSolutions
                      ? "review"
                      : pageName?.toLowerCase().includes("test")
                        ? "test"
                        : "quiz"
                  }
                />
              )}
            </>
          )}
        </div>
      );
    }

    switch (activeComponent) {
      case "subject":
        return (
          <div className="subjects-list">
            {subjects?.map((item) => {
              const isActive = String(activeId) === String(item.id);
              const completematch = completed?.next_data?.find(
                (items) => items?.key === item?.key,
              );
              return (
                <div
                  key={item.id}
                  className={isActive ? "subject-row--active-wrapper" : ""}
                >
                  <CourseVerticallCard
                    title={item.name}
                    completed={
                      completematch?.completed_topic_count ??
                      completematch?.completed_count ??
                      0
                    }
                    total={
                      completematch?.total_topic_count ??
                      completematch?.page_count ??
                      0
                    }
                    statusText={
                      completematch?.completed ||
                      ((completematch?.completed_topic_count ??
                        completematch?.completed_count) ===
                        (completematch?.total_topic_count ??
                          completematch?.page_count) &&
                        (completematch?.completed_topic_count ??
                          completematch?.completed_count) !== 0)
                        ? "Completed"
                        : "Not Completed"
                    }
                    onClick={() => onSelectLeft && onSelectLeft(item)}
                  />
                </div>
              );
            })}
          </div>
        );
      case "topics":
        return (
          <div className="subjects-list">
            {subjects?.map((item) => {
              const isActive = String(activeId) === String(item.id);
              const completematch = completed?.next_data?.find(
                (items) => items?.key === item?.key,
              );
              return (
                <div
                  key={item.id}
                  className={isActive ? "subject-row--active-wrapper" : ""}
                >
                  <CourseVerticallCard
                    title={item.name}
                    completed={
                      completematch?.completed_subtopic_count ??
                      completematch?.completed_count ??
                      0
                    }
                    total={
                      completematch?.total_subtopic_count ??
                      completematch?.page_count ??
                      0
                    }
                    statusText={
                      completematch?.completed ||
                      ((completematch?.completed_subtopic_count ??
                        completematch?.completed_count) ===
                        (completematch?.total_subtopic_count ??
                          completematch?.page_count) &&
                        (completematch?.completed_subtopic_count ??
                          completematch?.completed_count) !== 0)
                        ? "Completed"
                        : "Not Completed"
                    }
                    onClick={() => onSelectLeft && onSelectLeft(item)}
                  />
                </div>
              );
            })}
          </div>
        );

      case "subtopics":
        return (
          <div className="subjects-list">
            {subjects?.map((item) => {
              const isActive = String(activeId) === String(item.id);
              let completematch = "";
              if (completed?.next_data?.length > 0) {
                completematch = completed?.next_data?.find(
                  (items) => items?.key === item?.key,
                );
              } else {
                completematch = completed;
              }
              return (
                <div
                  key={item.id}
                  className={isActive ? "subject-row--active-wrapper" : ""}
                >
                  <CourseVerticallCard
                    title={item.name}
                    completed={completematch?.completed_count ?? 0}
                    total={completematch?.page_count ?? 0}
                    statusText={
                      completematch?.completed ||
                      (completematch?.completed_count ===
                        completematch?.page_count &&
                        completematch?.completed_count !== 0)
                        ? "Completed"
                        : "Not Completed"
                    }
                    onClick={() => onSelectLeft && onSelectLeft(item)}
                  />
                </div>
              );
            })}
          </div>
        );

      case "courses":
        return (
          <div className="courses-grid">
            {subjects?.map((subject) => (
              <CourseCard key={subject.id} course={subject} />
            ))}
          </div>
        );

      case "content":
      case "active_recall_content":
        return (
          <div className="content-page">
            <Content
              content={contentData}
              isMarkAsComplete={isMarkAsComplete}
              setIsMarkAsComplete={setIsMarkAsComplete}
            />
            {/* Quiz action bar — bottom of content page, user-only */}
            {activeComponent === "content" &&
              !isAdmin &&
              !isInstitution &&
              isContentQuizEnabled &&
              contentQuizData &&
              Array.isArray(contentQuizData?.[0]?.question) &&
              contentQuizData[0].question.length > 0 && (
                <div className="content-quiz-bottom-bar">
                  {!contentQuizData[0].content_quiz_completed && (
                    <button
                      className="btn-attempt-test attempt"
                      onClick={() => {
                        setQuizViewMode(false);
                        setShowContentQuizPopup(true);
                      }}
                    >
                      ✏️ Attempt Test
                    </button>
                  )}

                  {(contentQuizData[0].content_quiz_completed ||
                    (!contentQuizData[0].content_quiz_completed &&
                      (contentQuizData[0].no_of_attempts || 0) > 0)) && (
                    <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                      <button
                        className="btn-attempt-test view-answers"
                        onClick={() => {
                          setQuizViewMode(true);
                          setShowContentQuizPopup(true);
                        }}
                      >
                        View Answers
                      </button>
                    </div>
                  )}

                  {checkIsAiEvalEnabled() && !isAdmin && (
                    <button
                      className="ps-row__aieval-chip regenerate"
                      style={{
                        marginLeft: "8px",
                        cursor: "pointer"
                      }}
                      onClick={async () => {
                        try {
                          setIsPersonalizedLoading(true);
                          await regenerateContentQuizApi(pageTitle || "subtopic", pageKey, activeId);
                          if (refreshContentQuizData) {
                            await refreshContentQuizData(activeId);
                          }
                          fetchQuizEvals(true);
                          if (pollQuizEval && activeId) {
                            pollQuizEval(activeId);
                          }
                        } catch (err) {
                          console.error("Error regenerating personalized quiz:", err);
                        } finally {
                          setIsPersonalizedLoading(false);
                        }
                      }}
                      disabled={isPersonalizedLoading}
                    >
                      {isPersonalizedLoading ? "Regenerating..." : "Regenerate Quiz"}
                    </button>
                  )}
                </div>


              )}
          </div>
        );

      case "quiz":
        return resultsLoading ? (
          <GlobalLoader />
        ) : (isTestSubmitted || isPageCompleted) &&
          !showSolutions &&
          !isReattempting ? (
          renderScoreChart()
        ) : (
          <MCQ
            questions={contentData}
            current={mcqCurrent}
            setCurrent={setMcqCurrent}
            answers={mcqAnswers}
            setAnswers={setMcqAnswers}
            pageName={pageName}
            mode={showSolutions ? "review" : "quiz"}
            isAdmin={isAdmin}
            hideQuestionSubmit={!showSolutions}
          />
        );

      case "truefalse":
        return resultsLoading ? (
          <GlobalLoader />
        ) : (isTestSubmitted || isPageCompleted) &&
          !showSolutions &&
          !isReattempting ? (
          renderScoreChart()
        ) : (
          <TrueFalse
            questions={contentData?.questions || tfQuestions}
            current={mcqCurrent}
            setCurrent={setMcqCurrent}
            answers={mcqAnswers}
            setAnswers={setMcqAnswers}
            mode={showSolutions ? "review" : "quiz"}
            isAdmin={isAdmin}
          />
        );

      case "fillups":
        return resultsLoading ? (
          <GlobalLoader />
        ) : (isTestSubmitted || isPageCompleted) &&
          !showSolutions &&
          !isReattempting ? (
          renderScoreChart()
        ) : (
          <Fillups
            questions={contentData?.questions || contentData}
            current={mcqCurrent}
            setCurrent={setMcqCurrent}
            answers={mcqAnswers}
            setAnswers={setMcqAnswers}
            mode={showSolutions ? "review" : "quiz"}
            isAdmin={isAdmin}
          />
        );

      case "conversation":
      case "analysis":
        let analysisQuestion = "Analyze this topic.";
        try {
          let content = contentData;
          if (Array.isArray(content)) {
            content = content[0];
          }

          if (content?.content) {
            let parsedContent = content.content;
            if (typeof parsedContent === "string") {
              try {
                parsedContent = JSON.parse(parsedContent);
              } catch (e) {}
            }

            if (parsedContent?.questions?.[0]?.question) {
              analysisQuestion = parsedContent.questions[0]?.question;
            } else if (parsedContent?.question) {
              analysisQuestion = parsedContent.question;
            }
          }
        } catch (e) {
          console.error("Error parsing analysis question:", e);
        }

        return <ConversationalAnalysis question={analysisQuestion} />;

      case "match":
        return resultsLoading ? (
          <GlobalLoader />
        ) : (isTestSubmitted || isPageCompleted) &&
          !showSolutions &&
          !isReattempting ? (
          renderScoreChart()
        ) : (
          <Match
            data={contentData}
            mode={showSolutions ? "review" : "quiz"}
            answers={mcqAnswers}
            setAnswers={setMcqAnswers}
            questionId={activeId}
            isAdmin={isAdmin}
            hideQuestionSubmit={!showSolutions}
          />
        );

      case "material_item":
      case "materials":
        return (
          <div className="content-page">
            <MaterialsRenderer content={contentData} />
          </div>
        );

      case "pdf":
        return <PdfViewer />;

      case "video":
        return <VideoPlayer {...contentData} />;

      case "test":
      case "active_recall_test":
        if (testPageLoading) {
          return (
            <div className="content-page">
              <GlobalLoader />
            </div>
          );
        }

        if (showAiTutor) {
          return (
            <>
              <AiTutor
                lessons={aiLessons}
                isLoading={aiLoading}
                error={aiError}
                setShowAiTutor={setShowAiTutor}
                pageId={activeId}
                pageKey={pageKey}
                pageTitle={pageTitle}
                aiTutorContentId={aiTutorContentId}
                setAiTutorContentId={setAiTutorContentId}
                onRegenerate={handleRegenerateAiTutor}
                isRegenerating={aiLoading}
              />

            </>
          );
        }

        const currentPageStatus = (() => {
          if (!completed || !activeId) return null;
          const checkList = (list) => {
            if (!Array.isArray(list)) return null;
            for (const item of list) {
              const itemId =
                typeof item.page === "object"
                  ? item.page?._id || item.page?.id
                  : item.page;
              if (String(itemId) === String(activeId)) {
                return item;
              }

              if (Array.isArray(item.child_pages)) {
                const childMatch = item.child_pages.find((child) => {
                  const childPageId =
                    typeof child.page === "object"
                      ? child.page?._id || child.page?.id
                      : child.page;
                  return String(childPageId) === String(activeId);
                });
                if (childMatch) {
                  return childMatch;
                }
              }
            }
            return null;
          };
          return (
            checkList(completed.data) || checkList(completed.active_recall)
          );
        })();

        const isCompletedBothFalse =
          !currentPageStatus ||
          (!currentPageStatus.completed &&
            !currentPageStatus.content_quiz_completed);
        const isReattemptRequired =
          currentPageStatus &&
          currentPageStatus.completed &&
          !currentPageStatus.content_quiz_completed;

        if (testResult && !isCompletedBothFalse) {
          const passPercentage =
            typeof testResult.summary?.pass_percentage === "number"
              ? testResult.summary.pass_percentage
              : 70;

          const showConfetti = testResult.percentage >= passPercentage;

          const feedbackItems =
            Array.isArray(testResult.summary?.feedback) && testResult.summary.feedback.length > 0
              ? testResult.summary.feedback
              : Array.isArray(testResult.feedback)
              ? testResult.feedback
              : [];
          const rewardsCoins =
            (lastTestRewards && typeof lastTestRewards.coins === "number"
              ? lastTestRewards.coins
              : null) ?? 0;
          const rewardsXp =
            (lastTestRewards && typeof lastTestRewards.xp === "number"
              ? lastTestRewards.xp
              : null) ?? 0;

          const getPerformanceWrapperClassByScore = (percentage) => {
            if (percentage < 50) {
              return "score-feedback-wrapper--needs-improvement";
            }
            if (percentage <= 75) {
              return "score-feedback-wrapper--good";
            }
            return "score-feedback-wrapper--excellent";
          };

          const getFeedbackSectionClassByScore = (percentage) => {
            if (percentage < 50) {
              return "feedback-section--needs-improvement";
            }
            if (percentage <= 75) {
              return "feedback-section--good";
            }
            return "feedback-section--excellent";
          };

          return (
            <div className="score-container">
              {isReattemptRequired && activeComponent === "test" && (
                <div
                  className="reattempt-alert-message"
                  style={{
                    backgroundColor: "#fff2e6",
                    color: "#d97706",
                    border: "1px solid #fde68a",
                    padding: "16px",
                    borderRadius: "12px",
                    marginBottom: "20px",
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "15px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  Your score doesn't reach the pass percentage, so please
                  reattempt the test.
                </div>
              )}
              {showConfetti && !showAiTutor && (
                <Confetti
                  width={windowSize.width}
                  height={windowSize.height - 100}
                  recycle={false}
                  numberOfPieces={200}
                  gravity={0.1}
                />
              )}
              <div
                className={`score-feedback-wrapper custom-scrollbar ${getPerformanceWrapperClassByScore(
                  testResult.percentage,
                )}`}
              >
                <div className="score-chart-container">
                  <div className="score-chart-wrapper">
                    <AnimatedCircularProgress score={testResult.percentage} />
                  </div>
                  {testResult.percentage >= 40 && (
                    <motion.div
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.8, delay: 0.5 }}
                      className="gamification-rewards"
                    >
                      <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{
                          type: "spring",
                          stiffness: 200,
                          delay: 0.8,
                        }}
                        style={{
                          borderRadius: "12px",
                          color: "#000",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "20px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Lottie
                          animationData={levelUpAnimation}
                          loop={true}
                          style={{ width: 100, height: 100 }}
                        />
                        {rewardsXp} XP
                      </motion.div>

                      <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{
                          type: "spring",
                          stiffness: 200,
                          delay: 1.0,
                        }}
                        style={{
                          borderRadius: "12px",
                          color: "#000",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "20px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Lottie
                          animationData={goldCoinAnimation}
                          loop={true}
                          style={{ width: 100, height: 100 }}
                        />
                        {rewardsCoins} credits
                      </motion.div>
                    </motion.div>
                  )}
                </div>
                {feedbackItems.length > 0 && (
                  <div
                    className={`feedback-section ${getFeedbackSectionClassByScore(
                      testResult.percentage,
                    )}`}
                  >
                    {feedbackItems.map((fb, index) => {
                      const weakTopics = fb.weak_topics || [];
                      const isExpanded = !!expandedWeakTopics[index];
                      const maxCollapsedTopics = 2;

                      return (
                        <div key={index} className="feedback-item">
                          <div className="feedback-header">
                            {testResult?.percentage !== undefined && (
                              <div
                                className={`performance-badge ${
                                  testResult.percentage < 50
                                    ? "needs-improvement"
                                    : testResult.percentage <= 75
                                      ? "good"
                                      : "excellent"
                                }`}
                              >
                                {fb.performance_level}
                              </div>
                            )}
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              {(fb.improvement_advice ||
                                fb.title ||
                                fb.content) && (
                                <button
                                  className="additional-feedback-btn"
                                  onClick={() => setShowFeedbackModal(true)}
                                >
                                  Additional Feedback
                                </button>
                              )}
                            </div>
                          </div>

                          {/* {weakTopics.length > 0 && (
                            <div className="weak-topics-section">
                              <div className="weak-topics-label">
                                Areas to Focus On:
                              </div>
                              <div className="weak-topics-list">
                                {visibleTopics.map((topic, topicIndex) => (
                                  <span
                                    key={topicIndex}
                                    className="weak-topic-tag"
                                  >
                                    {topic}
                                  </span>
                                ))}
                                {remainingCount > 0 && !isExpanded && (
                                  <span
                                    className="weak-topic-tag weak-topic-more-tag"
                                    onClick={() =>
                                      setExpandedWeakTopics((prev) => ({
                                        ...prev,
                                        [index]: true,
                                      }))
                                    }
                                  >
                                    +{remainingCount}
                                  </span>
                                )}
                              </div>
                            </div>
                          )} */}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="score-actions flex-gap">
                <button
                  className="btn-reattempt"
                  onClick={() => {
                    const queryParams = new URLSearchParams({
                      title: pageTitle || "subtopic",
                      key: pageKey || selectedCourse?.key || "",
                      review: "true",
                    });
                    if (activeComponent === "active_recall_test") {
                      queryParams.append("active-recall", "true");
                      if (parent) {
                        queryParams.append("parent_id", parent);
                      }
                    }
                    navigate(`/test/${activeId}?${queryParams.toString()}`);
                  }}
                >
                  Show Answers
                </button>
                <button
                  className="btn-reattempt"
                  onClick={() => {
                    Cookies.remove(`test_result_${activeId}`);
                    setTestResult(null);
                    const queryParams = new URLSearchParams({
                      title: pageTitle || pageName || "subtopic",
                      key: pageKey || selectedCourse?.key || "",
                      test_page_content_id: activeId,
                      retest: "true",
                    });
                    if (activeComponent === "active_recall_test") {
                      queryParams.append("active-recall", "true");
                      if (parent) {
                        queryParams.append("parent_id", parent);
                      }
                    }
                    navigate(`/test?${queryParams.toString()}`);
                  }}
                >
                  Reattempt
                </button>
                {/* <button
                  className="btn-reattempt btn-show-answer"
                  onClick={() => setShowAiPopup(true)}
                >
                  Generate more Questions
                </button>{" "} */}
                {showTeachButton && (
                  <button className="btn-primary" onClick={handleTeachClick}>
                    Teach
                  </button>
                )}
              </div>

              <AiGenerationPopup
                isOpen={showAiPopup}
                onClose={() => setShowAiPopup(false)}
                pageKey={pageKey || selectedCourse?.key}
                field={pageTitle || pageName || "subtopic"}
                questions={testPageData?.attempt_data || []}
                onGenerate={(difficulty) => {
                  setShowAiPopup(false);
                }}
              />

              <FeedbackPopup
                isOpen={showFeedbackModal}
                onClose={() => setShowFeedbackModal(false)}
                feedbackItems={feedbackItems}
                percentage={testResult?.percentage || 0}
                aiEvalData={testEvals[getTestEvalKey()]}
                isAiEvalEnabled={checkIsAiEvalEnabled()}
                isAdmin={isAdmin}
                onAiChipClick={() => {
                  setShowFeedbackModal(false);
                  handleTestAiEvalClick();
                }}
                onRegenerate={handleRegenerateTestEval}
                isRegenerating={isRegeneratingTest}
                isEvaluating={evalLoading}
              />
            </div>
          );
        }
        const testMeta = testPageData || {};
        const testTitle = testMeta.name || testMeta.title || pageName || "Test";
        const durationMinutes = testMeta.duration || 30;

        let totalQuestions = 0;
        if (Array.isArray(testMeta?.questions)) {
          totalQuestions = testMeta?.questions?.length;
        } else if (Array.isArray(testMeta.content)) {
          totalQuestions = testMeta.content.length;
        }

        return (
          <div className="content-page">
            <StartTestCard
              title={testTitle}
              durationMinutes={durationMinutes}
              totalQuestions={totalQuestions}
              onStart={() => {
                const queryParams = new URLSearchParams({
                  title: pageTitle || pageName || "subtopic",
                  key: pageKey || selectedCourse?.key || "",
                  test_page_content_id: activeId,
                });

                if (activeComponent === "active_recall_test") {
                  queryParams.append("active-recall", "true");
                  if (parent) {
                    queryParams.append("parent_id", parent);
                  }
                }

                navigate(`/test?${queryParams.toString()}`);
              }}
            />
          </div>
        );

      default:
        return (
          <div className="content-page">
            {selectedCourse && (
              <>
                <div className="content-header">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "16px",
                      flexWrap: "wrap",
                    }}
                  >
                    <h2>{selectedCourse.title}</h2>
                    {personalizedContentData && (
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <Tabs
                          className="personalized-tabs"
                          value={activeContentTab}
                          onChange={handleContentTabChange}
                          textColor="primary"
                          indicatorColor="primary"
                        >
                          <Tab label="Predefined Content" value="normal" />
                          <Tab
                            label="Personalized Content"
                            value="personalized"
                          />
                        </Tabs>
                        {activeContentTab === "personalized" && personalizedContentId && checkIsAiEvalEnabled() && !checkIsAdmin() && (
                          <div className="ai-eval-chip-wrapper" style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                            {contentEvals[personalizedContentId] ? (
                              <button
                                className="ps-row__aieval-chip evaluated"
                                onClick={handleAiEvalClick}
                                disabled={evalLoading}
                              >
                                Eval: {contentEvals[personalizedContentId].overall_score}/10
                              </button>
                            ) : (
                              <button
                                className={`ps-row__aieval-chip ${evalLoading ? 'loading' : ''}`}
                                onClick={handleAiEvalClick}
                                disabled={evalLoading}
                              >
                                {evalLoading ? "Evaluating..." : "Evaluate with AI"}
                              </button>
                            )}
                            <button
                              className="ps-row__aieval-chip regenerate"
                              onClick={handleGeneratePersonalizedContent}
                              disabled={isPersonalizedLoading}
                              title="Regenerate Personalized Content with AI"
                            >
                              {isPersonalizedLoading ? "Regenerating..." : "Regenerate"}
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <Content
                  content={
                    personalizedContentData &&
                    activeContentTab === "personalized"
                      ? { type: "content", content: personalizedContentData }
                      : contentData
                  }
                  isMarkAsComplete={isMarkAsComplete}
                  setIsMarkAsComplete={setIsMarkAsComplete}
                />
              </>
            )}
          </div>
        );
    }
  };

  return (
    <>
      {(isLoading || isPersonalizedLoading || loading) && <GlobalLoader />}
      {isSuccessPopup && (
        <SuccessPopup
          message="Audio Generated Successfully"
          open={isSuccessPopup}
          onClose={() => {
            setIsSuccessPopup(false);
          }}
        />
      )}
      {renderComponent()}
      {/* Floating Content Quiz button — shown alongside the Ainstein assistant */}
      {!isAdmin &&
        !isInstitution &&
        activeComponent === "content" &&
        isContentQuizEnabled &&
        contentQuizData &&
        Array.isArray(contentQuizData?.[0]?.question) &&
        contentQuizData[0].question.length > 0 && (
          <div className="content-quiz-float-btn">
            {!contentQuizData[0].content_quiz_completed && (
              <button
                className="btn-attempt-test attempt"
                onClick={() => {
                  setQuizViewMode(false);
                  setShowContentQuizPopup(true);
                }}
              >
                ✏️ Attempt Test
              </button>
            )}

            {(contentQuizData[0].content_quiz_completed ||
              (!contentQuizData[0].content_quiz_completed &&
                (contentQuizData[0].no_of_attempts || 0) > 0)) && (
              <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                <button
                  className="btn-attempt-test view-answers"
                  onClick={() => {
                    setQuizViewMode(true);
                    setShowContentQuizPopup(true);
                  }}
                >
                   View Answers
                </button>
              </div>
            )}
          </div>
        )}

      {/* Content Quiz Popup — standalone, outside renderComponent to avoid re-mount */}
      <ContentQuizPopup
        isOpen={showContentQuizPopup}
        onClose={() => setShowContentQuizPopup(false)}
        questions={contentQuizData?.[0]?.question || []}
        viewMode={quizViewMode}
        setQuizViewMode={setQuizViewMode}
        pageKey={pageKey}

        activeId={activeId}
        pageTitle={pageTitle || "subtopic"}
        refreshContentQuizData={refreshContentQuizData}
        contentQuizData={contentQuizData}
        onQuizSubmitSuccess={() => {
          fetchQuizEvals(true);
          const targetId = activeId || contentQuizData?.[0]?.id || testPageData?.id;
          if (targetId) pollQuizEval(targetId);
          if (onQuizSubmitSuccess) {
            onQuizSubmitSuccess();
          }
        }}
        refreshQuizEval={() => fetchQuizEvals(true)}
        pollQuizEval={pollQuizEval}
        aiEvalData={quizEvals[activeId] || (contentQuizData?.[0]?.id && quizEvals[contentQuizData[0].id]) || (testPageData?.id && quizEvals[testPageData.id])}
        isAiEvalEnabled={checkIsAiEvalEnabled()}
        isAdmin={isAdmin}
      />


      <AiEvalBreakdownPopup
        open={evalPopupOpen}
        onClose={() => setEvalPopupOpen(false)}
        evalData={selectedEvalData}
      />
    </>
  );
};

export default RenderPage;
